// https://github.com/vuejs/vue-router/blob/dev/examples/scroll-behavior/app.js
export function scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      // savedPosition is only available for popstate navigations.
      return savedPosition
    } else {
      const position = {}
  
      // scroll to anchor by returning the selector
      if (to.hash) {
        const hashAnchor = document.querySelector(to.hash);
        // bypass #1number check
        if (/^#\d/.test(to.hash) || hashAnchor) {
            var toTop = hashAnchor.offsetTop;
            // specify offset of the element

            toTop -= document.getElementById('header').offsetHeight;

            return window.scrollTo({ 
                top: toTop, 
                behavior: 'smooth' 
              })
        }
  
        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        return false
      }
  
      return new Promise(resolve => {
        // check if any matched route config has meta that requires scrolling to top
        if (to.matched.some(m => m.meta.scrollToTop)) {
          // coords will be used if no selector is provided,
          // or if the selector didn't match any element.
          position.x = 0
          position.y = 0
        }
  
        resolve(position);        
      })
    }
  }